import React, {useEffect, useState} from 'react'
import {FormContainer} from "../../../../palette/Palette";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem, RangeRule, AsyncRule} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db,} from "../../../../firebase/Firebase";
import format from 'date-fns/format'
import {Button} from "devextreme-react/button";
import isAfter from "date-fns/isAfter";
import Alerts from "../../../../palette/Alerts";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FilterDelete} from "../../../../utils/HelpFunctions";

const buttonOptions = {
    text: 'Actualizar',
    type: 'success',
    useSubmitBehavior: true,
    id: 'add-button-routes',
    icon: 'far fa-check-circle'
};

const now = new Date();

const state = [{ID: 1, state: 'Registrado'}, {ID: 2, state: 'Anulado'}]

const typesValues = [{value: false, text: '% (Porcentaje)',}, {value: true, text: '$ (Valor)'}];

function PromotionsEditForm(props) {

    const {
        setVisibleGrid, setTrigger, trigger, setEdit, dataSource, setDataEdit, promotions,
        DataStore
    } = props


    const {companyName, idCompany,} = DataStore

    const [submitButton, setSubmitButton] = useState({...buttonOptions})
    const [between, setBetween] = useState(false)
    const [load, setLoad] = useState(true)
    const [success, setSuccess] = useState(false)

    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        setSubmitButton({...buttonOptions, disabled: false})
    }, [])

    const mainPath = db.collection(companyName).doc(idCompany).collection('Promotions')

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        setTrigger(!trigger)
                        setEdit(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const alertRender = () => {
        return (
            <Alerts severity={'error'} body={'La promoción no puede estar en un rango anterior de fechas'}/>
        )
    }

    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Promoción actualizada exitosamente!'}/>
        )
    }

    const onValueChanged = () => {
        setDataEdit({...dataSource, percentage: null, value: null})
    }

    const onValueDateChanged = () => {
        if (dataSource.start && dataSource.end) {
            const start = format(dataSource.start, 'yyyy-MM-dd')
            const end = format(dataSource.end, 'yyyy-MM-dd')

            const filterPromotions = FilterDelete(promotions, 'cod', dataSource.cod)

            let finished = false

            filterPromotions.forEach((item) => {
                const itemStart = format(item.start, 'yyyy-MM-dd')
                const itemEnd = format(item.end, 'yyyy-MM-dd')

                if (!finished) {
                    if (itemStart <= start && start <= itemEnd) {
                        setBetween(true)
                        setDataEdit({...dataSource, start: null, end: null})
                        finished = true
                    } else {
                        if (itemStart <= end && end <= itemEnd) {
                            setBetween(true)
                            setDataEdit({...dataSource, start: null, end: null})
                            finished = true
                        } else {
                            if (start <= itemStart && itemStart <= end) {
                                setBetween(true)
                                setDataEdit({...dataSource, start: null, end: null})
                                finished = true
                            } else {
                                if (end <= itemStart && itemEnd <= end) {
                                    setBetween(true)
                                    setDataEdit({...dataSource, start: null, end: null})
                                    finished = true
                                } else {
                                    setBetween(false)
                                    finished = false
                                }
                            }
                        }
                    }
                }

            })
        }
    }

    function sendRequestStart(value) {
        let result = isAfter(new Date(), value)
        const nowStr = format(now, 'yyyy-MM-dd')
        const valueStr = format(value, 'yyyy-MM-dd')

        let endStr;
        let compare;
        if (dataSource.end) {
            endStr = format(dataSource.end, 'yyyy-MM-dd')
            compare = endStr >= valueStr
        }

        let equal = valueStr >= nowStr

        if (dataSource.end) {
            if (!compare) {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(false);
                    }, 500);
                });
            } else {
                if (result && !equal) {
                    return new Promise((resolve) => {
                        setTimeout(function () {
                            resolve(false);
                        }, 500);
                    });
                } else {
                    return new Promise((resolve) => {
                        setTimeout(function () {
                            resolve(true);
                        }, 500);
                    });
                }
            }
        } else {
            if (result && !equal) {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(false);
                    }, 500);
                });
            } else {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(true);
                    }, 500);
                });
            }
        }
    }

    function sendRequestEnd(value) {

        let result = format(new Date(), 'yyyy-MM-dd') > format(value, 'yyyy-MM-dd');


        let startStr;
        const valueStr = format(value, 'yyyy-MM-dd')

        if (dataSource.start) {

            startStr = format(dataSource.start, 'yyyy-MM-dd')
            let equal = valueStr >= startStr

            console.log(result, equal)

            if (result) {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(false);
                    }, 500);
                });
            } else {
                if (!equal) {
                    return new Promise((resolve) => {
                        setTimeout(function () {
                            resolve(false);
                        }, 500);
                    });
                } else {
                    return new Promise((resolve) => {
                        setTimeout(function () {
                            resolve(true);
                        }, 500);
                    });
                }
            }
        } else {
            if (result) {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(false);
                    }, 500);
                });
            }
            {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(true);
                    }, 500);
                });
            }
        }
    }

    function asyncValidationStartDate(params) {
        return sendRequestStart(params.value);
    }

    function asyncValidationEndDate(params) {
        return sendRequestEnd(params.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSubmitButton({...submitButton, disabled: true})
        setLoad(false)

        await mainPath.doc(dataSource.docId).set(dataSource).then(() => {
            setSuccess(true)
            setTrigger(!trigger)
            setLoad(true)
            setTimeout(() => {
                setVisibleGrid(true)
                setEdit(false)
                setSuccess(false)
                setSubmitButton({...submitButton, disabled: false})
            }, 1700)
        }).catch(() => {
            setSuccess(false)
            setLoad(true)
            setSubmitButton({...submitButton, disabled: false})
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
        })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="cancellations-container">
                <HeaderPage icon={'fab fa-opencart'} text={'Editar promoción'} load={load}
                            textLoad={'Actualizando...'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            formData={dataSource}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="create-promotions"
                        >
                            <GroupItem caption="Datos" colCount={2}>
                                <SimpleItem dataField="cod" label={{text: 'Código de promoción'}}
                                            editorOptions={{width: 100, disabled: true}}>
                                    <RequiredRule message="Ingrese el código"/>
                                </SimpleItem>
                                <SimpleItem dataField="state" label={{text: 'Estado'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                dataSource: state,
                                                displayExpr: "state",
                                                valueExpr: "state",
                                                value: dataSource.state,
                                            }}/>
                            </GroupItem>

                            <GroupItem colCount={1}>

                                <SimpleItem dataField="tittle" label={{text: 'Titulo'}}
                                            editorOptions={{width: 270, maxLength: 20}}>
                                    <RequiredRule message="Titulo de la promoción"/>
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem colCount={2}>
                                <SimpleItem dataField={'valueRadio'}
                                            label={{text: 'Tipo de valor'}}
                                            editorType={'dxRadioGroup'}
                                            editorOptions={{
                                                dataSource: typesValues,
                                                valueExpr: 'value',
                                                layout: 'horizontal',
                                                displayExpr: 'text',
                                                onValueChanged: (e) => onValueChanged(e)
                                            }}/>
                                <SimpleItem dataField={dataSource.valueRadio ? 'value' : 'percentage'}
                                            label={{text: dataSource.valueRadio ? 'Valor' : 'Porcentaje'}}
                                            editorType="dxNumberBox"
                                            editorOptions={{
                                                format: dataSource.valueRadio ? "$ #,##0.##" : "#0%",
                                            }}>
                                    <RangeRule message={dataSource.valueRadio ? 'No se puede permitir este valor' :
                                        'El porcentaje maximo debe ser de el 100%'}
                                               max={dataSource.valueRadio ? 1000 : 1}/>
                                    <RequiredRule message="Ingrese un valor"/>
                                </SimpleItem>

                                <SimpleItem dataField="start" label={{text: 'Fecha de inicio'}} editorType="dxDateBox"
                                            editorOptions={{
                                                onValueChanged: onValueDateChanged,
                                                min: new Date()
                                            }}>
                                    <RequiredRule message="Ingrese la fecha de inicio"/>
                                    <AsyncRule
                                        message="No se puede ingresar fecha mayor a la fecha de expiración"
                                        validationCallback={asyncValidationStartDate}/>
                                </SimpleItem>

                                <SimpleItem dataField="end" label={{text: 'Fecha de expiración'}} editorType="dxDateBox"
                                            editorOptions={{onValueChanged: onValueDateChanged, min: new Date()}}>
                                    <RequiredRule message="Ingrese la fecha de inicio"/>
                                    <AsyncRule
                                        message="No se puede ingresar fecha menor a la actual o a la fecha de inicio"
                                        validationCallback={asyncValidationEndDate}/>
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem colCount={1}>
                                <SimpleItem dataField="numClients" label={{text: 'Número de usos'}}
                                            editorOptions={{width: 100}} editorType={'dxNumberBox'}>
                                    <RequiredRule message="Ingrese el código"/>
                                </SimpleItem>
                                {between && <SimpleItem render={alertRender}/>}
                                {success &&
                                <SimpleItem render={renderSuccess}/>
                                }
                            </GroupItem>

                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )

}


export default PromotionsEditForm
